import { BRAND } from "@garageregister/shared";

const testimonials = [
  {
    quote: "Finally an app that understands car guys. I track every oil change, every mod, every receipt. It\u2019s like a digital logbook for my garage.",
    name: "Mike R.",
    handle: "@mikebuilds",
    vehicle: "2019 Toyota Supra MK5",
  },
  {
    quote: "The AI scanning is a game changer. I just take a photo of my receipts and everything gets filed automatically. No more shoeboxes of paperwork.",
    name: "Sarah K.",
    handle: "@sarahwrenches",
    vehicle: "2017 Jeep Wrangler JK",
  },
  {
    quote: "I\u2019ve been using spreadsheets for years to track mods across 4 cars. RevHead Pro replaced all of them in one afternoon.",
    name: "Dave T.",
    handle: "@davegarage",
    vehicle: "1995 Mazda Miata NA",
  },
];

export function Testimonials() {
  return (
    <section className="bg-[#151D2E] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-heading text-3xl font-bold text-[#E8EDF2] sm:text-4xl">
            Built for enthusiasts, by enthusiasts
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-[#7A8FA3]">
            Join the growing community of car, motorcycle, and powersport owners
            who trust {BRAND.name}.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <div key={t.name} className="rounded-xl border border-[#253448] bg-[#0C1222] p-6">
              <div className="flex gap-0.5 text-[#FBBF24]">
                {[1, 2, 3, 4, 5].map((s) => (
                  <svg key={s} className="h-4 w-4 fill-current" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              <p className="mt-4 text-sm leading-relaxed text-[#E8EDF2]">
                &ldquo;{t.quote}&rdquo;
              </p>

              <div className="mt-6 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-[#253448] flex items-center justify-center text-sm font-semibold text-[#4DB8C7]">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-[#E8EDF2]">{t.name}</p>
                  <p className="text-xs text-[#7A8FA3]">{t.vehicle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
